import {defineCustomElement} from 'extensions/ui-utils';
import {html, LitElement, nothing} from 'lit';
import {classMap} from 'lit/directives/class-map.js';
import stylesheet from './invoice-lookup.scss?as=stylesheet';
import 'extensions/ui-components/x-loader';
import 'extensions/ui-components/g-modal';

export class InvoiceLookup extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			ctaText: {
				attribute: 'cta-text',
				type: String
			},
			invoices: {
				type: String
			},
			loading: {
				type: Boolean
			}
		};
	}

	constructor () {
		super();
		this.invoice = '';
		this.loading = false;
		this.errorMessage = '';
		this.invoices = '';
		this.ctaText = 'Download Invoices';
	}

	async apiRequest (data) {
		this.loading = true;

		const response = await fetch(window.mivaJS?.API_Url, {
			body: JSON.stringify(data),
			headers: {
				'Content-Type': 'application/json'
			},
			method: 'POST'
		});

		this.loading = false;
		return response.json();
	}

	async handleLookup (e, type, invoice) {
		e.preventDefault();
		const invoiceNumber = this.shadowRoot.getElementById('invoice-number');

		if (type === 'form') {
			this.invoice = invoiceNumber.value;
		}

		if (type === 'link') {
			this.invoice = invoice;
		}


		const requestBody = {
			function: 'DOWNLOAD_INVOICE',
			// eslint-disable-next-line camelcase
			invoice: this.invoice
		};

		this.invoiceResponse = await this.apiRequest(requestBody);

		if (this.invoiceResponse.success === 0) {
			this.errorMessage = html`<span class="error-icon" aria-hidden="true"></span> Unable to locate invoice number. Please contact General Assist.`;
		} else {
			this.errorMessage = '';
			this.downloadPDF(this.invoiceResponse.data);
		}

		this.requestUpdate();
	}

	downloadPDF (pdf) {
		const linkSource = `data:application/pdf;base64,${pdf}`;
		const downloadLink = document.createElement('a');
		const fileName = `${this.invoice}.pdf`;

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	}

	renderLookupButton () {
		if (this.loading) {
			return html`<div class="loading-graphic-container u-border-none u-text-normal"><x-loader class="loading-graphic"></x-loader></div>`;
		}
		return html`<input class="c-control-group__button c-button c-button--small u-font-small u-cta-style--primary" type="submit" value="Find" @click="${e => this.handleLookup(e, 'form')}">`;
	}

	renderLookupForm () {
		return html`
			<form method="post">
				<fieldset>
					<legend class="u-hide-visually">Search Invoices</legend>
					<ul class="c-form-list">
						<li class="c-form-list__item c-form-list__item--full">
							<label class="u-font-small" for="Order_ID">Missing an invoice? We can help you find it.</label>
						</li>
						<li class="c-form-list__item c-control-group u-flex">
							<input id="invoice-number" class="c-form-input c-control-group__field" type="text" name="Order_ID" placeholder="Invoice, Sales Order, or Purchase Order Number" required>
							${this.renderLookupButton()}
						</li>
					</ul>
				</fieldset>
			</form>
		`;
	}

	renderInvoiceList () {
		if (this.invoices === '') {
			return nothing;
		}

		return html`
			<div class="invoice-list">
				${this.invoiceArray.map(invoice => html`<span class="invoice-link" @click="${e => this.handleLookup(e, 'link', invoice)}">${invoice}</span>`)}
			</div>
		`;
	}

	render () {
		const classes = {
			'error-container': true,
			hidden: this.errorMessage === ''
		};

		return html`
			<g-modal small="true" align="top" class="x-invoice-lookup-modal">
				<div slot="title" class="x-invoice-lookup-order__title">
					${this.ctaText === 'Download Invoices' ? 'Select an Invoice to Download' : 'Lookup an Invoice'}
				</div>
				<a slot="trigger" class="order-summary-customer__action-link">${this.ctaText}</a>
				<div slot="content" class="x-invoice-lookup__content">
					${this.renderInvoiceList()}
					${this.renderLookupForm()}
					<div class="${classMap(classes)}">${ this.errorMessage }</div>
				</div>
			</g-modal>
		`;
	}

	get invoiceArray () {
		return this.invoices.split(',');
	}
};

defineCustomElement('x-invoice-lookup', InvoiceLookup);
